module.exports = __webpack_public_path__ + "img/pregnant.37a05a5f.png";